import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import ContextProvider from '../provider/ContextProvider'
import Navigation from './Navigation'
import CartShelf from './CartShelf'

const theme = {
  primarycolor: '#000',
  black: '#000',
  grey: '#3A3A3A',
  lightgrey: '#E1E1E1',
  blueFont: '#0657F2',
  offWhite: '#EDEDED',
  maxWidth: '1200px',
  borderRadius: '5px',
}

const Wrapper = styled.div`
  padding: 0 3em;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;

  @media screen and (max-width: 1000px) {
    display: block;
    margin: 0 auto;
    padding: 0 2em;
  }

  .Form__formSection___1PPvW {
    input {
      border: 1px solid;
      min-width: 250px;
      padding: 5px;
      margin: 10px 0;
      background: transparent;
    }
    a {
      cursor: pointer;
    }
  }

  .Section__sectionFooterSecondaryContent___Nj41Q {
    display: block;
    margin: 2em 0;

    a {
      cursor: pointer;
    }
  }

  .Button__button___vS7Mv {
    background: none;
    border: 1px solid;
    padding: 5px 12px;
    min-width: 100px;
    cursor: pointer;
    margin: 3em 0 0;

    &:hover {
      background: black;
      color: white;
    }
  }
`

const GlobalStyle = createGlobalStyle`
 html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }

  h1 {
    font-weight:normal;
    text-transform:uppercase;
    font-size:1.1em;
  }

  html {
  overflow-x:hidden;
  width: 100%;
    height: 100%;
  }

  body {
    color: ${props => props.theme.primarycolor};
    margin:0;
    padding:0;
    border:0;
    width: 100%;
    height: 100%;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .cart {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 30%;
    height: 100%;
    min-width: 300px;
    background-color: white;
    z-index: 1000;
    border-left:1px solid;
    padding: 2em 1em;
    transition: transform 500ms;
    transform: translateX(100%)};
  
    .open {
    transform: translateX(0%)};
  
    }
  
   }



  footer {
    text-align:center;
  }



  

  a {
    color: ${props => props.theme.primarycolor};
    text-decoration:none;
  }

  footer {
    margin:2em 0;
  }
 

  input {

    &::-webkit-input-placeholder {
      opacity:1; /* Chrome/Opera/Safari */
    }

    &::-moz-placeholder { /* Firefox 19+ */
      opacity:1;
}
&:-ms-input-placeholder { /* IE 10+ */
  opacity:1;
}
&:-moz-placeholder { /* Firefox 18- */
  opacity:1;
}
    
  }


`

const Layout = ({ children, location }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <ThemeProvider theme={theme}>
      <>
        <ContextProvider>
          <GlobalStyle />
          <Wrapper>
            <header role="heading" aria-level="1">

              <Navigation siteTitle={data.site.siteMetadata.title} />
              <CartShelf />
            </header>

            <main>{children}</main>
          </Wrapper>
        </ContextProvider>
      </>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
